'use client';

import { domAnimation, LazyMotion } from 'framer-motion';

export default function MotionProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
}
